import React, { Component, createContext } from "react";
import { auth, db } from "../services/firebase";
import { Route, Redirect } from "react-router-dom";
import Loading from "../components/Loading";
import { GlobalContext } from "./GlobalProvider";
import firebase from "firebase/app";

export const UserContext = createContext({
  user: null,
  doc: null,
  teamDoc: null,
  memberInfo: {},
  requests: {},
});

class UserProvider extends Component {
  static contextType = GlobalContext;

  constructor(props) {
    super(props);
    this.state = {
      user: null,
      doc: null,
      teamDoc: null,
      memberInfo: {},
      requests: {},
      setState: this.setState,
      loading: true,
    };
  }
  componentDidMount() {
    auth.onAuthStateChanged((userAuth) => {
      this.setState({ user: userAuth });
      if (!userAuth) {
        this.setState({ loading: false });
      } else {
        db.collection(`users`)
          .doc(userAuth.uid)
          .onSnapshot((doc) => {
            this.setState({ loading: false, doc: doc });
            if (doc.data()?.teamId) {
              db.collection(`teams`)
                .doc(doc.data().teamId)
                .onSnapshot((teamDoc) => {
                  if (
                    !teamDoc.exists ||
                    (teamDoc &&
                      !teamDoc.data().teamMembers.includes(userAuth.uid))
                  ) {
                    db.collection(`users`)
                      .doc(userAuth.uid)
                      .set(
                        { teamId: firebase.firestore.FieldValue.delete() },
                        { merge: true }
                      );
                    return;
                  }
                  if (teamDoc.data().code) {
                    db.collection(`code`)
                      .doc(teamDoc.data().code)
                      .collection(`requests`)
                      .onSnapshot((querySnapshot) => {
                        for (let change of querySnapshot.docChanges()) {
                          if (change.type === "removed") {
                            this.setState((state) => {
                              delete state.requests[change.doc.id];
                              return state;
                            });
                          } else {
                            this.setState((state) => {
                              state.requests[change.doc.id] = change.doc.data();
                              return state;
                            });
                          }
                        }
                      });
                  }
                  this.setState((state) => {
                      for (let k in state.memberInfo) {
                          if (!teamDoc.data().teamMembers.includes(k)) {
                              delete state.memberInfo[k];
                          }
                      }
                      return state
                  })
                    this.setState({ teamDoc: teamDoc });
                  teamDoc.data().teamMembers.forEach((memberId) => {
                    db.collection(`users`)
                      .doc(memberId)
                      .get()
                      .then((memberDoc) => {
                        this.setState((state) => {
                          state.memberInfo[memberDoc.id] = memberDoc.data();
                          return state;
                        });
                      });
                  });
                });
            }
            if (doc.data()?.teamRequest) {
              db.collection(`users`)
                .doc(doc.id)
                .collection(`responses`)
                .doc(doc.data().teamRequest)
                .onSnapshot((querySnapshot) => {
                  if (!querySnapshot.data()) return;

                  if (querySnapshot.data().success) {
                    db.collection(`users`).doc(doc.id).set(
                      {
                        teamId: querySnapshot.data().teamId,
                        teamRequest: firebase.firestore.FieldValue.delete(),
                      },
                      { merge: true }
                    );
                  } else {
                    db.collection(`users`).doc(doc.id).set(
                      {
                        teamRequest: firebase.firestore.FieldValue.delete(),
                      },
                      { merge: true }
                    );
                  }
                  db.collection(`users`)
                    .doc(doc.id)
                    .collection(`responses`)
                    .doc(doc.data().teamRequest)
                    .delete();
                });
            }
          });
      }
    });
  }

  render() {
    if (this.state.loading) {
      return (
        <UserContext.Provider value={this.state}>
          <Loading timeout={3500}>
            <Route key="/signin" exact path="/signin">
              {this.props.children}
            </Route>
            <Route key="/" path="/">
              <Redirect to="/signin" />
            </Route>
          </Loading>
        </UserContext.Provider>
      );
    }
    if (this.state.user) {
      if (this.state.doc && this.state.doc.exists) {
        return (
          <React.Fragment>
            <Route key="/signin" exact path="/signin">
              <Redirect to="/dashboard" />
            </Route>
            <Route key="/register" exact path="/register">
              <Redirect to="/dashboard" />
            </Route>
            <Route key="/" path="/">
              <UserContext.Provider value={this.state}>
                {this.props.children}
              </UserContext.Provider>
            </Route>
          </React.Fragment>
        );
      }
      return (
        <UserContext.Provider value={this.state}>
          <Loading timeout={3500}>
            <Route key="/register" exact path="/register">
              {this.props.children}
            </Route>
            <Route key="/" path="/">
              <Redirect to="/register" />
            </Route>
          </Loading>
        </UserContext.Provider>
      );
    }
    return (
      <UserContext.Provider value={this.state}>
        <Route key="/signin" exact path="/signin">
          {this.props.children}
        </Route>
        <Route key="/" path="/">
          <Redirect to="/signin" />
        </Route>
      </UserContext.Provider>
    );
  }
}

export default UserProvider;
